var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.resources,"size":"small","highlight-row":"","stripe":"","max-height":"700"},scopedSlots:_vm._u([{key:"barcode",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.product ? row.product.barcode : 'N/A')+"\n    ")]}},{key:"product_name",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.product ? row.product.product_name_en : 'N/A')+"\n    ")]}},{key:"unit_of_measure",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.unit_of_measure ? row.unit_of_measure.uom_name_en : 'N/A')+"\n    ")]}},{key:"cost",fn:function(ref){
var row = ref.row;
return [_c('ts-display-currency',{attrs:{"amount":row.input_cost,"currency_id":row.input_currency_id}})]}},{key:"amount",fn:function(ref){
var row = ref.row;
return [_c('ts-display-currency',{attrs:{"amount":row.input_grand_total,"currency_id":row.input_currency_id}})]}},{key:"converted_amount",fn:function(ref){
var row = ref.row;
return [_c('ts-display-currency',{attrs:{"amount":row.grand_total,"currency_id":row.currency_id}})]}},{key:"action",fn:function(ref){
var row = ref.row;
return [_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.viewSerialProduct(row)}}},[_c('i',{staticClass:"fas fa-list"})])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }